import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import SearchLayout from '../components/Layouts/Search'
import DataTable from '../components/DataTable'
import Checkbox from '../components/form/Checkbox'
import Button from '../UniformComponents/Button'
import Anchor from '../UniformComponents/Anchor'
import Badge from '../UniformComponents/Badge'
import Tooltip from '../UniformComponents/Tooltip'
import { removeQueryParam, setQueryParam, getQueryParam } from '../utils/helpers'
import UserStore from './UserStore'
import UserEdit from './UserEdit'

const USER_PARAM = 'userId'

@observer
class UserSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            userId: 0,
        }
        this.userStore = new UserStore(props.store)
        this.setColumns()
    }

    async componentDidMount() {
        const { store, location } = this.props
        const { userStore } = this

        store.breadcrumps = [
            {
                name: 'user',
                url: '/user',
                title: 'User',
            },
        ]

        await userStore.initSearch()

        this.checkQueryParam(location)
    }

    checkQueryParam = (location) => {
        const userId = getQueryParam(location, USER_PARAM)
        if (userId === -1) return
        if (userId !== 0) {
            this.setState({ userId })
        }
        this.toggleModal()
    }

    setColumns = () => {
        const { store } = this.props
        this.columns = [
            {
                name: 'Status',
                key: 'active',
                cellClass: 'status',
                dataTransform: (active) => {
                    switch (active) {
                        case true: return (
                            <Badge
                                type="success"
                                cssClass="status-badge"
                                label={i18n.t('userSearch.table.active', 'Active')}
                                icon="fa-regular fa-circle-check"
                            />
                        )
                        case false: return (
                            <Badge
                                type="error"
                                cssClass="status-badge"
                                label={i18n.t('userSearch.table.inactive', 'Inactive')}
                                icon="fa-regular fa-ban"
                            />
                        )
                        default: return null
                    }
                },
            },
            {
                name: 'First name',
                key: 'firstName',
                cellClass: 'bold',
            },
            {
                name: 'Last name',
                key: 'lastName',
                cellClass: 'bold',
            },
            {
                name: 'Role',
                key: 'role',
                cellClass: 'bold',
                dataTransform: (role) => (
                    i18n.t(`userRole_${role}`)
                ),
            },
            {
                name: 'Email',
                key: 'email',
                cellClass: 'bold',
            },
            {
                name: '',
                key: 'userId',
                cellClass: 'center',
                dataTransform: (userId, { role }) => (
                    store.userData.role <= role ? (
                        <div className="survey-btn-wrapper">
                            <Anchor
                                cssClass="icon-link-btn"
                                onClick={() => {
                                    this.handleOpenModal(userId)
                                }}
                            >
                                <Tooltip
                                    text={i18n.t('edit_user', 'Edit User')}
                                    direction="bottom"
                                />
                                <i className="fa-light fa-edit" />
                            </Anchor>
                        </div>
                    ) : null
                ),
            },
        ]
    }

    toggleModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }))
    }

    handleOpenModal = (userId) => {
        const { location, history } = this.props

        setQueryParam(location, history, USER_PARAM, userId)
        this.setState({ userId })
        this.toggleModal()
    }

    handleCloseModal = () => {
        const { location, history } = this.props

        removeQueryParam(location, history, USER_PARAM)
        this.setState({ userId: 0 })
        this.toggleModal()
        this.userStore.resetFormState()
    }

    renderFilterOptions = () => {
        const { userStore } = this
        return (
            <Fragment>
                <fieldset className="filter">
                    <p className="legend-title">
                        User status
                    </p>
                    <Checkbox
                        name="active"
                        onBlur={userStore.toggleActive}
                        checked={userStore.active}
                        label="Active"
                    />
                    <Checkbox
                        name="inactive"
                        onBlur={userStore.toggleInActive}
                        checked={userStore.inActive}
                        label="Inactive"
                    />
                </fieldset>
            </Fragment>
        )
    }

    renderButtons = () => {
        const { store } = this.props
        return (
            <div className="right">
                {store.userData.role < 150 && (
                    <Button
                        cssClass="add-button primary regular"
                        onClick={() => { this.handleOpenModal(0) }}
                        icon="fa-light fa-user-plus"
                        label={i18n.t('add_user', 'Add new user')}
                    />
                )}
            </div>
        )
    }

    renderTablePanel = () => {
        const { userStore } = this
        return (
            <DataTable
                store={userStore}
                inMemory
                dataSet={userStore.filteredList || []}
                columns={this.columns}
            />
        )
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('userSearch.introText'),
        }}
        />
    )

    render() {
        const { userStore } = this
        const { store } = this.props
        const { showModal, userId } = this.state
        return (
            <Fragment>
                <SearchLayout
                    pageTitle="All users"
                    renderFilterOptions={this.renderFilterOptions}
                    renderButtons={this.renderButtons}
                    renderTablePanel={this.renderTablePanel}
                    renderGuide={this.renderGuide}
                    searchStore={userStore}
                />
                <UserEdit
                    showModal={showModal}
                    handleCloseModal={this.handleCloseModal}
                    store={store}
                    userStore={userStore}
                    userId={userId}
                />
            </Fragment>
        )
    }
}

export default UserSearch
